import React from 'react';
import { inject, observer } from 'mobx-react';
import H5SidebarTopicList from './h5';
import PCSidebarTopicList from './pc';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import type { TopicAction } from '@stores/topic/action';
import { withRouter, RouteComponentProps } from 'react-router-dom';

interface SidebarTopicListProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    topic?: TopicAction;
}
interface SidebarTopicListState {
    topicList: any
}
type SidebarTopicListAllProps = SidebarTopicListProps & RouteComponentProps;
@inject('app', 'site', 'user', 'topic')
@observer
// 下载APP入口，h5是悬浮在页面顶部，pc是放在页面内容右侧
class SidebarTopicList extends React.Component<SidebarTopicListAllProps, SidebarTopicListState> {
    constructor(props: SidebarTopicListAllProps) {
        super(props);

        // 从 props 中获取初始值设置到 state
        this.state = {
        topicList: [],
        };
    }

    async componentDidMount() {
        // 可以在这里添加初始化逻辑
        // console.log('这是header');
        await this.getTopicList();
        
    }
    getTopicList = async () => {
        const { topic } = this.props;
        if (topic && topic.getTopicList) {
            await topic.getTopicList({ 'page[number]': 1, 'page[size]': 10, 'filter[isHot]': 1 });
            const rawList = topic.listStore.getList({ namespace: 'topicList' }) || [];
            // 转换为 TopicList 需要的格式
            this.setState({ topicList: rawList });
        }
    }

    topicClick = async (item) => {
        const { topic } = this.props;
        topic.setFollowTopicFocusId(item.id);
        window.open(`/topicDetail/${item.id}`)
        // this.props.history.push(`/topicDetail/${item.id}`);
    }   

    render() {
        const { site, app, topic, ...props } = this.props;
        const { topicList } = this.state;
        const platform = app?.platform || 'h5';
        
        if (platform === 'pc') {
            return <PCSidebarTopicList topicClick={(item:any) =>this.topicClick(item)} topicList={topicList} {...props} />;
        }
        
        return <H5SidebarTopicList {...props} />;

    }
}

export default withRouter(SidebarTopicList);